export default "__VITE_ASSET__DnKYbqfh__"